export const isValidIndicator = (item: any): boolean => {
  if (!item?.id || !item?.category) return false;
  const hasName = typeof item?.name === 'string' && item.name.trim().length > 0;
  const hasIndicator = typeof item?.indicator === 'string' && item.indicator.trim().length > 0;
  return hasName || hasIndicator;
};

export const getIndicatorDisplayName = (item: any): string | undefined => item?.name ?? item?.indicator;

export const sanitizeIndicators = (list?: any[]): any[] => {
  return Array.isArray(list) ? list.filter(isValidIndicator) : [];
};

export const addIndicator = (list: any[] | undefined, indicator: any): any[] => {
  const sanitized = sanitizeIndicators(list);
  if (sanitized.find((val) => val.id === indicator.id)) return sanitized;
  return [...sanitized, indicator];
};

export const removeIndicator = (list: any[] | undefined, indicator: any): any[] => {
  const sanitized = sanitizeIndicators(list);
  const index = sanitized.findIndex((val) => val.id === indicator.id);
  if (index < 0) return sanitized;
  const copy = sanitized.slice();
  copy.splice(index, 1);
  return copy;
};
